export default __webpack_public_path__ + "static/kloss_okladka_small-cab1a67d99533631003bbcd25c304b7c.jpg";